import React, {ComponentPropsWithoutRef} from "react";

export function Content({ children }: { children: React.ReactNode }) {
  return (
    <div className="my-3 mx-3 scrollbar table-wrapper">
      {children}
    </div>
  );
}

export function Table({ children, ...props }: { children?: React.ReactNode } & ComponentPropsWithoutRef<'table'>) {
  return (
    <table {...props} className="table table-sm table-bordered table-hover table-condensed">
      {children}
    </table>
  )
}

export function Cell({ children, ...props }: { children?: React.ReactNode } & ComponentPropsWithoutRef<'td'>) {
  return (
    <td {...props} style={{verticalAlign: 'middle', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'}}>
      {children}
    </td>
  );
}

export function CenterCell({ children, ...props }: { children?: React.ReactNode } & ComponentPropsWithoutRef<'td'>) {
  return (
    <td {...props} className='text-center' style={{verticalAlign: 'middle', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'}}>
      {children}
    </td>
  )
}
